// Generated by scripts/update-seeq-icons.js from src/svg/seeq/plus-assets.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcPlusAssets = {
  prefix: 'fak',
  iconName: 'plus-assets' as IconName,
  icon: [
    1239,
    1024,
    [],
    'e950',
    'M335.9 152.2l390.4-146.5c20.5-7.7 43-7.7 63.2 0.2l390.3 146.4c35.1 13.1 58.4 46.7 58.4 84.3v422.5c0 34-19.1 65.3-49.7 80.6l-390.4 195.2c-25.3 12.8-55.2 12.8-80.5 0l-139.9-70c26.7-44 42-95.6 42-150.8 0-160.9-130.4-291.2-291.2-291.3-17.4 0-34.4 1.5-50.9 4.5v-190.7c0-37.5 23.3-71.3 58.3-84.4zM1118.3 257.5l-360.3-135.2-360.3 135.2v2l360.3 146.4 360.3-146.4v-2zM818 511v279.5l300.3-150.1v-251.4l-300.3 122zM561.9 716c0-126.2-102.3-228.5-228.5-228.5s-228.5 102.3-228.5 228.5c0 126.2 102.3 228.5 228.5 228.4s228.5-102.3 228.5-228.4zM376.5 672.9h101.2c5.6 0 10.2 4.5 10.1 10.1v65.9c0 5.6-4.5 10.2-10.1 10.1h-101.2v101.2c0 5.6-4.5 10.2-10.2 10.2h-65.8c-5.6 0-10.2-4.5-10.1-10.2v-101.2h-101.2c-5.6 0-10.2-4.5-10.2-10.1v-65.9c0-5.6 4.5-10.2 10.2-10.1h101.2v-101.2c0-5.6 4.5-10.2 10.1-10.1h65.8c5.6 0 10.2 4.5 10.2 10.1v101.2z',
  ],
} satisfies IconDefinition;
